import { SCREEN, SIDE_NAV_COMMON_MAPPING, SIDE_NAV_SPOT_EVENT_MAPPING, removeKeysStorage } from '@common/Common';
// import IconButton from '@common/component/atoms/IconButton';
import LinkedDataIcon from '@common/component/atoms/LinkedDataIcon';
import SideNavItem from '@common/component/molecules/SideNavItem';
import SideNavItemForManual from '@common/component/molecules/SideNavItemForManual';
import { StoreInfo } from '@common/external/StoresApi';
import { Collapse, Icon } from '@material-ui/core';
import { withRouter, RouteComponentProps, Link } from 'react-router-dom';
import classNames from 'classnames';
import React, { Component } from 'react';
import Dropdown from '@common/component/atoms/Dropdown';
import LogoutModal from '../../../container/organisms/LogoutModalContainer';

export interface SideNavHandler {
  userName: string;
  clearSearchCondition: () => void;
  clearLocationPathAndFilterCondition: () => void;
  updateHistoryLocationPathName: (pathname: string) => void;
}

export interface SideNavProps extends SideNavHandler, RouteComponentProps {
  isHiddenHead: boolean;
  stores: StoreInfo[];
  targetStores: string[];

  /**
   * サイドバーの縮小状態. trueの時、縮小サイズで表示する
   */
  isCollapsed: boolean;

  toggleCollapse: () => void;
}
interface SideNavItemState {
  /**
   * 開閉状態. trueのときに閉じている
   * 他の行をクリックして連動して閉じるようにするには、isCollapsedAccordion, onHandleCollapse はpropsで受け渡し、上位階層で開閉状態を管理する
   */
  isCollapsedAccordion: boolean;
  anchorEl: HTMLElement | null;

  /**
   * 店舗選択モーダルの開閉状態
   */
  isOpenModal: boolean;
  /**
   * ログアウトモーダルの開閉状態
   */
  isOpenLogoutModal: boolean;
}

class SideNav extends Component<SideNavProps, SideNavItemState> {
  private expandNavRef: React.RefObject<HTMLUListElement>;
  constructor(props: SideNavProps) {
    super(props);

    this.state = {
      isCollapsedAccordion: false,
      isOpenModal: false,
      anchorEl: null,
      isOpenLogoutModal: false,
    };

    this.expandNavRef = React.createRef<HTMLUListElement>();
    this.onHandleCollapse = this.onHandleCollapse.bind(this);
  }

  addGASpotEventIntoSideNavItems() {
    Object.values(SIDE_NAV_SPOT_EVENT_MAPPING['AGENCY']).forEach(({ spotEvent, className }) => {
      document.querySelector(`.${className}`)?.setAttribute('onclick', spotEvent || '');
    });
  }

  componentDidMount() {
    this.props.updateHistoryLocationPathName(this.props.location.pathname);
    this.addGASpotEventIntoSideNavItems();
    document
      .querySelector(`.${SCREEN.LINKED_DATA_RESULT.ID}`)
      ?.setAttribute('onclick', "_ga.spotEvent('[AGENCY]_代理店','サイドメニュー','登録連携情報一覧')");
  }

  onHandleCollapse() {
    this.setState({ isCollapsedAccordion: !this.state.isCollapsedAccordion });
  }

  componentDidUpdate(prevProps: SideNavProps) {
    if (this.props.isCollapsed !== prevProps.isCollapsed) {
      this.addGASpotEventIntoSideNavItems();
    }
  }

  renderExpandContent() {
    return (
      <>
        <div className='uc-sidenav__title'>商談中</div>
        <ul className='uc-sidenav__expand-nav' ref={this.expandNavRef} data-testid='uc-sidenav__expand-nav-container'>
          <SideNavItem
            className={SIDE_NAV_COMMON_MAPPING.underNegotiationPeriod.className}
            to={`${SCREEN.UNDER_NEGOTIATION.URL}/period`}
            activePaths={[`${SCREEN.UNDER_NEGOTIATION.URL}/period`]}
            onclick={this.props.clearLocationPathAndFilterCondition}>
            <Icon className='uc-sidenav__left-icon'>description</Icon>
            <span className='uc-sidenav__label'>対応期間別</span>
          </SideNavItem>
          <SideNavItem
            className={SIDE_NAV_COMMON_MAPPING.underNegotiationAction.className}
            to={`${SCREEN.UNDER_NEGOTIATION.URL}/action`}
            activePaths={[`${SCREEN.UNDER_NEGOTIATION.URL}/action`]}
            onclick={this.props.clearLocationPathAndFilterCondition}>
            <Icon className='uc-sidenav__left-icon'>description</Icon>
            <span className='uc-sidenav__label'>次のアクション</span>
          </SideNavItem>
          <SideNavItem
            className={SIDE_NAV_COMMON_MAPPING.underNegotiationProd.className}
            to={`${SCREEN.UNDER_NEGOTIATION.URL}/prob`}
            activePaths={[`${SCREEN.UNDER_NEGOTIATION.URL}/prob`]}
            onclick={this.props.clearLocationPathAndFilterCondition}>
            <Icon className='uc-sidenav__left-icon'>description</Icon>
            <span className='uc-sidenav__label'>契約確率</span>
          </SideNavItem>
          <div className='uc-sidenav__title'>長期保留</div>
          <SideNavItem
            className={SIDE_NAV_COMMON_MAPPING.pendingNegotiationPending.className}
            to={`${SCREEN.PENDING_NEGOTIATION.URL}/pending`}
            activePaths={[`${SCREEN.PENDING_NEGOTIATION.URL}/pending`]}
            onclick={this.props.clearLocationPathAndFilterCondition}>
            <Icon className='uc-sidenav__left-icon'>description</Icon>
            <span className='uc-sidenav__label'>保留期間別</span>
          </SideNavItem>
          <SideNavItem
            className={SIDE_NAV_COMMON_MAPPING.pendingNegotiationAction.className}
            to={`${SCREEN.PENDING_NEGOTIATION.URL}/action`}
            activePaths={[`${SCREEN.PENDING_NEGOTIATION.URL}/action`]}
            onclick={this.props.clearLocationPathAndFilterCondition}>
            <Icon className='uc-sidenav__left-icon'>description</Icon>
            <span className='uc-sidenav__label'>次のアクション</span>
          </SideNavItem>
          <SideNavItem
            className={SIDE_NAV_COMMON_MAPPING.pendingNegotiationProd.className}
            to={`${SCREEN.PENDING_NEGOTIATION.URL}/prob`}
            activePaths={[`${SCREEN.PENDING_NEGOTIATION.URL}/prob`]}
            onclick={this.props.clearLocationPathAndFilterCondition}>
            <Icon className='uc-sidenav__left-icon'>description</Icon>
            <span className='uc-sidenav__label'>契約確率</span>
          </SideNavItem>
          <div className='uc-sidenav__title'>商談終了</div>
          <SideNavItem
            className={SIDE_NAV_COMMON_MAPPING.doneNegotiationResult.className}
            to={`${SCREEN.DONE_NEGOTIATION.URL}/result`}
            onclick={this.props.clearLocationPathAndFilterCondition}>
            <Icon className='uc-sidenav__left-icon'>description</Icon>
            <span className='uc-sidenav__label'>商談結果別</span>
          </SideNavItem>
        </ul>
        {/* <div className='uc-sidenav__title'>実績比較レポート</div>
        <ul className='uc-sidenav__expand-nav'>
          <SideNavItem to='#'>
            <span className='uc-sidenav__label'>対応実績</span>
          </SideNavItem>
        </ul>
        <div className='uc-sidenav__title'>その他のレポート</div>
        <ul className='uc-sidenav__expand-nav'>
          <SideNavItem to='#'>
            <span className='uc-sidenav__label'>更新月</span>
          </SideNavItem>
          <SideNavItem to='#'>
            <span className='uc-sidenav__label'>カスタムレポート</span>
          </SideNavItem>
        </ul> */}
      </>
    );
  }

  render() {
    const { isCollapsedAccordion, anchorEl, isOpenLogoutModal } = this.state;
    const { isHiddenHead, isCollapsed, toggleCollapse } = this.props;

    return (
      <div className={classNames('sidenav uc-sidenav', isCollapsed && 'uc-sidenav--close')} style={{ width: '240px', height: '100%' }}>
        {!isHiddenHead && (
          <div className='uc-sidenav__head sidenav__head u-pr0'>
            <h1 className='sidenav__head-title u-text-primary u-text-bold u-text-2l'>
              <img className='uc-sidenav__left-icon' src={`${process.env.PUBLIC_URL}/mikomi-icon.svg`} alt='icon' width='18' />
              <Link to='/' onClick={() => removeKeysStorage()}>
                見込顧客管理
              </Link>
            </h1>
            <Link to='#' className='sidenav__collapse-button' onClick={toggleCollapse}>
              <Icon className='uc-sidenav__left-icon u-mr0'>first_page</Icon>
            </Link>
          </div>
        )}
        <div className='uc-sidenav__content'>
          <ul className='uc-sidenav__nav'>
            <SideNavItem
              className={SIDE_NAV_COMMON_MAPPING.dashboard.className}
              to={SCREEN.DASHBOARD.URL}
              onclick={this.props.clearLocationPathAndFilterCondition}>
              <Icon className='uc-sidenav__left-icon'>dashboard</Icon>
              <span className='uc-sidenav__label'>ダッシュボード</span>
            </SideNavItem>
            <SideNavItem
              to={SCREEN.CUSTOMER_INFO_LIST.URL}
              onclick={() => this.props.clearSearchCondition()}
              data-testid='customer-info-list'>
              <Icon className='uc-sidenav__left-icon'>group</Icon>
              <span className='uc-sidenav__label'>顧客一覧</span>
            </SideNavItem>
            <SideNavItem
              className={SIDE_NAV_COMMON_MAPPING.negotiationList.className}
              to={SCREEN.NEGOTIATION_SEARCH_RESULT.URL}
              onclick={() => this.props.clearSearchCondition()}
              data-testid='search-result'>
              <Icon className='uc-sidenav__left-icon'>list_bulleted</Icon>
              <span className='uc-sidenav__label'>商談一覧</span>
            </SideNavItem>

            {/* サイドバーの拡大状態の時に表示 */}
            {!isCollapsed && (
              <li className={classNames('uc-sidenav__expand', !isCollapsedAccordion && 'uc-sidenav__expand--open')}>
                <Link className='uc-sidenav__expand-title' to='#' onClick={this.onHandleCollapse}>
                  <Icon className='uc-sidenav__left-icon'>assessment</Icon>
                  <span className='uc-sidenav__label'>レポート</span>
                </Link>
                <div className='uc-sidenav__expand-content'>
                  <Collapse in={!isCollapsedAccordion}>{this.renderExpandContent()}</Collapse>
                </div>
              </li>
            )}

            {/* サイドバーの縮小状態の時に表示 */}
            {isCollapsed && (
              /**
               * MEMO strict Modeで Warning「findDOMNode is deprecated in StrictMode.」が発生する
               * https://ja.reactjs.org/docs/strict-mode.html
               */
              <Dropdown
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                popover={this.renderExpandContent()}
                TransitionProps={{
                  onEntered: () => {
                    this.addGASpotEventIntoSideNavItems();
                  },
                }}
                onClose={() => this.setState({ anchorEl: null })}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'left',
                }}>
                <SideNavItem
                  to={`#`}
                  activePaths={[
                    `${SCREEN.UNDER_NEGOTIATION.URL}/period`,
                    `${SCREEN.UNDER_NEGOTIATION.URL}/prob`,
                    `${SCREEN.UNDER_NEGOTIATION.URL}/action`,
                    `${SCREEN.PENDING_NEGOTIATION.URL}/pending`,
                    `${SCREEN.PENDING_NEGOTIATION.URL}/prob`,
                    `${SCREEN.PENDING_NEGOTIATION.URL}/action`,
                    `${SCREEN.DONE_NEGOTIATION.URL}/result`,
                  ]}
                  onclick={(e: React.MouseEvent<HTMLElement>) => this.setState({ anchorEl: e.currentTarget })}>
                  <Icon className='uc-sidenav__left-icon'>assessment</Icon>
                  <span className='uc-sidenav__label'>レポート</span>
                </SideNavItem>
              </Dropdown>
            )}

            <SideNavItem
              className={SCREEN.LINKED_DATA_RESULT.ID}
              to={SCREEN.LINKED_DATA_RESULT.URL}
              onclick={() => {
                if (SCREEN.LINKED_DATA_RESULT.URL === this.props.location.pathname) return;
                this.props.clearSearchCondition();
              }}>
              <LinkedDataIcon className='uc-sidenav__left-icon' />
              <span className='uc-sidenav__label'>登録連携情報一覧</span>
            </SideNavItem>
          </ul>
          <hr className='uc-divider u-mb16 u-mh16' />
          <ul className='uc-sidenav__nav'>
            <SideNavItem
              className={SIDE_NAV_COMMON_MAPPING.visitSummary.className}
              to={`${SCREEN.VISIT.URL}/summary`}
              onclick={() => this.props.clearSearchCondition()}
              data-testid='side-navi--visit'>
              <Icon className='uc-sidenav__left-icon'>store</Icon>
              <span className='uc-sidenav__label'>来店予約</span>
            </SideNavItem>
            <SideNavItemForManual className={SIDE_NAV_COMMON_MAPPING.manualLink.className} to='#'>
              <Icon className='uc-sidenav__left-icon'>help</Icon>
              <span className='uc-sidenav__label'>
                マニュアル&nbsp;<Icon className='u-icon-ss'>launch</Icon>
              </span>
            </SideNavItemForManual>
          </ul>
        </div>
        <div className='uc-sidenav__footer u-p16'>
          {/*<div className='sidenav__collapsible'>
            <div
              className='agency-store-select uc-select uc-select--w-full u-mb8'
              data-testid='openModal'
              data-testid-e2e='sideNav-agencyStoreModal'
              onClick={(e: React.MouseEvent<HTMLElement>) => {
                if (this.props.stores.length > 1) {
                  this.setState({ isOpenModal: true });
                }
              }}>
              <span className='agency-store-select__note'>店舗:</span>
              <span className='agency-store-select__text' data-testid='storeSelectText' data-testid-e2e='sideNav-storeSelectText'>
                {this.props.targetStores.length === 1
                  ? this.props.stores.filter((v) => v.agencyCd === this.props.targetStores[0]).map((v) => v.shortName)
                  : this.props.targetStores.length + '店舗選択中'}
              </span>
            </div>
          </div>
          <StoreSelectModal
            isOpen={isOpenModal}
            onClose={() => {
              this.setState({ isOpenModal: false });
            }}
          />*/}
          <div className='uc-sidenav__footer u-p16'>
            <Link
              className='uc-header__link sidenav__collapsible'
              onClick={() => {
                this.setState({ isOpenLogoutModal: true });
              }}
              to='#'
              data-testid='logout-button'>
              <i className='uc-header__link-icon material-icons'>logout</i>
              <span className='uc-header__link-name'>ログアウト</span>
            </Link>
            <LogoutModal
              isOpen={isOpenLogoutModal}
              onClose={() => {
                this.setState({ isOpenLogoutModal: false });
              }}
              data-testid='logout-modal'
            />
          </div>
          <div className='u-flex'>
            <Link className='uc-header__link sidenav__collapsible' to='#' style={{ flex: 1 }}>
              <i className='uc-header__link-icon material-icons'>account_circle</i>
              <span className='uc-header__link-name' data-testid-e2e='sideNav-userName'>
                {this.props.userName}
              </span>
            </Link>
            {/* <IconButton icon='settings' /> */}
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(SideNav);
